import { useEffect, useState } from "react";
import { useMemberDrive } from "contexts/orchid-drive";
import type { OrchidDriveDirectory } from "contexts/orchid-drive/types";
import Attachments from "components/Dashboard/DoctorDashboard/attachments";
import useOrchidDriveDataInView from "../hooks/useOrchidDriveDataInView";
import { AmplitudePageName } from "utils/amplitude";
import { useTimeOnPageContext } from "contexts/time-on-page";

const STORAGE_DRIVE = "member-drive";
const AMPLITUDE_PAGE_NAME: AmplitudePageName = "pro-orchid-storage";

const OrchidStorage = () => {
  const [folderPaths, setFolderPaths] = useState<OrchidDriveDirectory[]>([]);

  const { setPage } = useTimeOnPageContext();
  useEffect(() => setPage(AMPLITUDE_PAGE_NAME), [setPage]);

  const { entries, createDirectory, uploadFile, deleteEntry, batchEntryOps } =
    useMemberDrive({
      memberDrive: [
        {
          directoryId: folderPaths[folderPaths.length - 1]?.directoryId || null,
          // TODO: add paging
          pages: [0],
        },
      ],
    });

  const dataInView = useOrchidDriveDataInView(entries[0].pages[0]);

  return (
    <Attachments
      storageDrive={STORAGE_DRIVE}
      dataInView={dataInView}
      createDirectory={createDirectory}
      uploadFile={uploadFile}
      deleteEntry={deleteEntry}
      batchEntryOps={batchEntryOps}
      folderPaths={folderPaths}
      setFolderPaths={setFolderPaths}
      amplitudePageName={AMPLITUDE_PAGE_NAME}
    />
  );
};

export default OrchidStorage;
